<template>
    <div class="downLoadPayFor">
        <img src="../../../assets/img/payforDownload.png">
        <div class="text-box">
            <p>您有一笔订单未付款</p>
            <p>请前往万顺叫车APP支付</p>
        </div>
        <p class="btn-bm" @click="downLoad">下载万顺叫车APP</p>
    </div>
</template>

<script>
import mobileType from "@/utils/mobileType";
import util from "@/utils/util";
import { Dialog } from "vant";
import appCommon from '../../../utils/appCommon'
export default {
    components: {},
    data() {
        return {
            params: {},
        };
    },
    created() {
    },
    mounted() {
	},
    methods: {
        downLoad() {
            appCommon.openClient()
        }
    }
};
</script>
<style lang="less" scoped>
.downLoadPayFor {
    position: relative;
    background: #fff;
    img {
        width: 100%;
        height: 272px;
    }
    .text-box {
        margin-top: 16px;
        text-align: center;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #242729;
        line-height: 32px;
    }
    .btn-bm {
        width: 351px;
        height: 54px;
        background: linear-gradient(164deg, #FF5133 0%, #FF1A1A 100%); 
        border-radius: 27px;
        text-align: center;
        margin: 0 auto;
        font-size: 20px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 54px;
        margin-top: 170px;
    }
}
</style>
